const { ajaxHandler } = require("./utilities/utilities");

/**
 * Update  billing info
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    const billingInfoForm = document.getElementById('vendora-products-billing-info');

    if (billingInfoForm) {
        billingInfoForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Get form data
            const formData = new FormData(billingInfoForm);

            const res = await ajaxHandler(formData);
            const { success, data } = res;

            alert(data);
        });
    }

})